import { combineReducers } from "redux"
import storage from "redux-persist/lib/storage"

import core from "./reducer_core"
import forgotPassword from "./reducer_forgot_password"
import userProfile from "./reducer_user_profile"
import menu from "./reducer_menu"
import packageReducer from "./reducer_package"
import order from "./reducer_order"

const appReducer = combineReducers({
    core,
    forgotPassword,
    userProfile,
    menu,
    packageReducer,
    order
})

const rootReducer = (state, action) => {
    if (action.type === "USER_LOGOUT") {
        Object.keys(state).forEach((key) => {
            storage.removeItem(`persist:${key}`)
        })
        state = undefined
    }

    return appReducer(state, action)
}

export default rootReducer
